// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"dd8c35c8","157":"d436fdd7","212":"84d7748e","330":"c21cd460","368":"e919721a","678":"72aefaa5"}[chunkId] + ".chunk.js";
};